/**
 * Pure filter constants + types for the Inventory module.
 *
 * Lives in its own file so `InventoryFilterRail.tsx` only exports a
 * component (the React Fast Refresh contract). Same split as
 * `date-presets.ts` next to `MarginsFilterRail.tsx`.
 */

export type StockFilter = 'all' | 'in_stock' | 'out_of_stock'

export type LotExpiryBucket = 'all' | 'expired' | 'within_30' | 'within_60'

export const LOT_EXPIRY_BUCKETS: { value: LotExpiryBucket; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'expired', label: 'Expired' },
  { value: 'within_30', label: '≤ 30 days' },
  { value: 'within_60', label: '≤ 60 days' },
]
